<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER QISMI -->
      <div class="header-row mb-4">
        <div class="d-flex align-items-center">
          <router-link class="back-circle-btn mr-3" :to="returnLocation">
            <b-icon icon="chevron-left"></b-icon>
          </router-link>
          <h2 class="page-title">
            {{ $t($route.name) }}
            <span v-if="$route.params.id != undefined" class="doc-num">№{{ $route.params.id }}</span>
          </h2>
          <button
            type="button"
            v-if="$route.params.id != undefined && settedrule.change == true && changedisabled"
            @click="Change()"
            class="btn-change ml-3"
          >
            <b-icon icon="unlock-fill" class="mr-1"></b-icon>{{ $t('Ўзгартириш') }}
          </button>
        </div>
        <div class="header-actions">
          <router-link class="btn-cancel mr-2" :to="returnLocation">
            {{ $t("Бекор қилиш") }}
          </router-link>
          <button :disabled="changedisabled" class="btn-save-light mr-2" type="button" @click="Savedokument('save')">
            <b-icon icon="save" class="mr-1"></b-icon>{{ $t("Сақлаш") }}
          </button>
          <button :disabled="changedisabled" class="btn-save" type="button" @click="Savedokument()">
            <b-icon icon="check-all" class="mr-1"></b-icon>{{ $t("Сақлаш ва беркитиш") }} <sup>ctrl+enter</sup>
          </button>
        </div>
      </div>

      <!-- HUJJAT SARLAVHA KARTASI -->
      <div class="modern-card doc-header-card mb-3">
        <div class="section-header">
          <b-icon icon="receipt"></b-icon>
          <span>{{ $t("Ҳужжат маълумотлари") }}</span>
        </div>
        <div class="row">
          <div class="col-md-2 col-6">
            <div class="form-unit">
              <label>{{ $t('Факт №') }}</label>
              <input :disabled="changedisabled" type="number" v-model="datas.number">
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="form-unit">
              <label>{{ $t('Вақт') }}</label>
              <input type="datetime-local" disabled="true" :value="SetDatetime(datas.datetime)">
            </div>
          </div>
          <div class="col-md-3 col-6">
            <div class="form-unit">
              <label>{{ $t('Склад') }}</label>
              <v-select
                :clearable="false"
                class="modern-vselect"
                :options="skladlist"
                :disabled="skladhave"
                v-model="datas.sklad_id"
                :reduce="name => name.id"
                label="name"
              >
                <template #search="{ attributes, events }">
                  <input class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
                </template>
                <template v-slot:no-options="{ search, searching }">
                  <template v-if="searching">
                    <em><b>{{ search }}</b></em> {{ $t("бўйича маьлумот йўқ") }}
                  </template>
                  <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-2 col-6">
            <div class="form-unit">
              <label>{{ $t('Сумма') }}</label>
              <div class="readonly-amount" :class="Number(datas.summa) < 0 ? 'amount-out' : 'amount-in'">
                {{ datas.summa | numFormat }}
              </div>
            </div>
          </div>
          <div class="col-md-2 col-6">
            <div class="form-unit">
              <label>{{ $t('Доллар Сумма') }} $</label>
              <div class="readonly-amount" :class="Number(datas.dollar_summa) < 0 ? 'amount-out' : 'amount-in'">
                {{ datas.dollar_summa | numFormat }}
              </div>
            </div>
          </div>
          <div class="col-md-2 col-6">
            <div class="form-unit">
              <label>{{ $t('Курс') }}</label>
              <input :disabled="changedisabled" type="text" v-model="datas.dollar_rate">
            </div>
          </div>
        </div>
      </div>

      <!-- QATORLAR KARTASI -->
      <div class="modern-card table-card">
        <div class="card-head-row">
          <div class="section-header mb-0">
            <b-icon icon="list-ul"></b-icon>
            <span>{{ $t("Қаторлар") }}</span>
          </div>
          <button v-if="changedisabled == false" class="add-row-btn" type="button" @click="Addtable()">
            <b-icon icon="plus-lg"></b-icon> {{ $t("Қатор қўшиш") }} <sup>F1</sup>
          </button>
        </div>

        <!-- UMUMIY BOSHQARUV: bir bosishda butun jadvalga qo'llanadi -->
        <div class="bulk-bar">
          <div class="bulk-item">
            <span class="bulk-label">{{ $t('Кирим / Чиқим') }}</span>
            <div class="kc-toggle">
              <button type="button" class="kc-btn kc-in" :class="{ active: globalType === true }"
                :disabled="changedisabled" @click="setGlobalType(true)">
                <b-icon icon="arrow-down-circle-fill" class="mr-1"></b-icon>{{ $t('Кирим') }}
              </button>
              <button type="button" class="kc-btn kc-out" :class="{ active: globalType === false }"
                :disabled="changedisabled" @click="setGlobalType(false)">
                <b-icon icon="arrow-up-circle-fill" class="mr-1"></b-icon>{{ $t('Чиқим') }}
              </button>
            </div>
          </div>
          <div class="bulk-item">
            <span class="bulk-label">Manba</span>
            <div class="kc-toggle">
              <button type="button" class="kc-btn kc-kassa" :class="{ active: globalSource === 'kassa' }"
                :disabled="changedisabled" @click="setGlobalSource('kassa')">
                <b-icon icon="cash-stack" class="mr-1"></b-icon>Kassa
              </button>
              <button type="button" class="kc-btn kc-safe" :class="{ active: globalSource === 'safe' }"
                :disabled="changedisabled" @click="setGlobalSource('safe')">
                <b-icon icon="safe2" class="mr-1"></b-icon>Seyf
              </button>
            </div>
          </div>
          <div class="bulk-item">
            <span class="bulk-label">{{ $t('Умумий тўлов тури') }}</span>
            <v-select
              :clearable="false"
              class="modern-vselect bulk-select"
              :options="paytypelist"
              v-model="globalPayType"
              :reduce="name => name.id"
              label="name"
              :disabled="changedisabled"
              @input="applyGlobalPayType"
            ></v-select>
          </div>
        </div>

        <div class="table-wrapper">
          <table class="doc-table">
            <thead>
              <tr>
                <th style="width: 50px">№</th>
                <th style="width: 22%">{{ $t('Асос') }} <span class="req">*</span></th>
                <th style="width: 16%">{{ $t('Тўлов тури') }} <span class="req">*</span></th>
                <th style="width: 14%">{{ $t('Тури') }} <span class="req">*</span></th>
                <th style="width: 11%">Manba</th>
                <th style="width: 16%; text-align: right;">{{ $t('Сумма') }} <span class="req">*</span></th>
                <th>{{ $t('Комментарий') }}</th>
                <th style="width: 50px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in datas.kassa_order_table" :key="index"
                :class="{ 'row-in': item.type === true, 'row-out': item.type === false }">
                <td class="text-center"><span class="id-badge">{{ index + 1 }}</span></td>

                <!-- Асос -->
                <td>
                  <v-select :disabled="changedisabled"
                    :clearable="false"
                    append-to-body
                    class="modern-vselect cell-select"
                    :class="{ 'is-empty': !item.base_id }"
                    :options="baselist"
                    v-model="item.base_id"
                    :reduce="name => name.id"
                    label="name"
                  >
                    <template #list-footer>
                      <li style="text-align: center;font-weight:bold;">f4 {{ $t("умумий рўйхат") }}</li>
                    </template>
                    <template #open-indicator="{ attributes }">
                      <span v-bind="attributes"></span>
                      <button :disabled="changedisabled" type="button" class="modallist"
                        @click="Selectbase(index)" v-b-modal.modal-baselist>
                        <b-icon icon="three-dots"></b-icon>
                      </button>
                    </template>
                    <template #selected-option="{ name }">
                      <div>{{ name }}</div>
                    </template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em> бўйича маьлумот йўқ
                        <button type="button" @click="base.name = search; Selectbase(index);"
                          class="pluss" v-b-modal.modal-base>+(ins)</button>
                      </template>
                      <em style="opacity: 0.5;" v-else>{{ $t("Маьлумот йўқ") }}</em>
                    </template>
                    <template #search="{ search, searching }">
                      <template v-if="searching">
                        <em><b>{{ search }}</b></em>
                        <input class="vs__search" v-bind="attributes" v-on="events" />
                      </template>
                    </template>
                  </v-select>
                </td>

                <!-- Тўлов тури -->
                <td>
                  <v-select :disabled="changedisabled"
                    :clearable="false"
                    append-to-body
                    class="modern-vselect cell-select"
                    :class="{ 'is-empty': !item.pay_type_id }"
                    :options="paytypelist"
                    v-model="item.pay_type_id"
                    @input="Summa()"
                    :reduce="name => name.id"
                    label="name"
                  ></v-select>
                </td>

                <!-- Тури (Кирим/Чиқим) -->
                <td>
                  <v-select :disabled="changedisabled"
                    :clearable="false"
                    append-to-body
                    class="modern-vselect cell-select type-select"
                    :class="{ 'is-empty': item.type === null || item.type === undefined }"
                    :options="typelist"
                    v-model="item.type"
                    @input="Summa()"
                    :reduce="name => name.id"
                    label="name"
                  ></v-select>
                </td>

                <!-- Manba: kassa yoki seyf -->
                <td>
                  <v-select :disabled="changedisabled"
                    :clearable="false"
                    append-to-body
                    class="modern-vselect cell-select"
                    :options="sourcelist"
                    v-model="item.source"
                    :reduce="s => s.id"
                    label="name"
                  ></v-select>
                </td>

                <!-- Сумма -->
                <td>
                  <vue-numeric :disabled="changedisabled"
                    separator="space"
                    v-model="item.summa"
                    @change="Summa()"
                    class="cell-input text-right"
                    v-bind:precision="2"
                  ></vue-numeric>
                </td>

                <!-- Комментарий -->
                <td>
                  <input :disabled="changedisabled" v-model="item.comment" class="cell-input" />
                </td>

                <!-- O'chirish -->
                <td class="text-center">
                  <button v-if="changedisabled == false" type="button" class="icon-btn del" @click="Trashitem(index)">
                    <b-icon icon="trash"></b-icon>
                  </button>
                </td>
              </tr>

              <tr v-if="datas.kassa_order_table && datas.kassa_order_table.length === 0">
                <td colspan="8" class="empty-row">{{ $t("Қатор қўшиш учун юқоридаги тугмани босинг") }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { print } from "../../components/mixins/print.js";
export default {
  name: "KassaorderForm",
  mixins: [print],
  data() {
    return {
      typelist: [
        { id: false, name: "Чиқим" },
        { id: true, name: "Кирим" }
      ],
      sklad: "",
      paytype: "",
      base: "",
      skladlist: [],
      paytypelist: [],
      baselist: [],
      sourcelist: [
        { id: 'kassa', name: 'Kassa' },
        { id: 'safe', name: 'Seyf' }
      ],
      // Umumiy boshqaruv: butun jadval uchun standart qiymatlar
      globalType: false,      // false = Чиқим (standart), true = Кирим
      globalPayType: null,    // standart: Накд (paytypelist yuklanganda o'rnatiladi)
      globalSource: 'kassa'   // pul qayerdan: kassa yoki seyf
    };
  },
  props: ["datas", "errors"],
  computed: {
    returnLocation() {
      const query = this.$route.query || {};
      if (query.returnTo !== 'service-profit') return {path:'/kassaorder/index'};
      return {path:'/xisobot/service-profit',query:{date1:query.date1,date2:query.date2,sklad:query.sklad,period:query.period,scroll:query.scroll}};
    }
  },
  created() {
    let self = this;
    self.$root.$refs.order = self;
    self.$root.$on("skladone", function(getdata) {
      self.sklad = getdata;
    });
    self.$root.$on("skladall", function(getdata) {
      self.skladlist = getdata;
    });
    self.$root.$on("paytypeone", function(getdata) {
      self.paytype = getdata;
    });
    self.$root.$on("paytypeall", function(getdata) {
      self.paytypelist = getdata;
    });
    self.$root.$on("baseone", function(getdata) {
      self.base = getdata;
    });
    self.$root.$on("baseall", function(getdata) {
      self.baselist = getdata;
    });
  },
  mounted: function() {
    let self = this;
    setTimeout(() => {
      self.Focus();
      self.SetRule('/kassaorder/index');
      // self.datas.datetime=self.SetDatetime(self.datas.datetime);
    }, 100);
  },
  watch: {
    paytypelist(list) {
      if (this.globalPayType == null && list && list.length) {
        this.globalPayType = this.findNaqdId(list);
      }
      this.initRowDefaults();
    },
    datas() {
      this.initRowDefaults();
    }
  },
  methods: {
    Summa() {
      this.datas.summa = 0;
      this.datas.dollar_summa = 0;
      let self = this;
      this.datas.kassa_order_table.forEach(function(key, value) {
        if(key.pay_type_id==3){
          if(key.type==true){
            self.datas.dollar_summa += parseFloat(key.summa);
          }else{
            self.datas.dollar_summa -= parseFloat(key.summa);
          }
        }else{
          if(key.type==true){
            self.datas.summa += parseFloat(key.summa);
          }else{
            self.datas.summa -= parseFloat(key.summa);
          }
        }
      });
    },
    Focus() {
      $(".vs__search")
        .eq(1)
        .focus();
    },
    Selectbase(index) {
      this.$store.state.selected_index = index;
    },
    Selectpaytype(index) {
      this.$root.$emit("tableselect", index);
    },
    Addtable() {
        this.datas.kassa_order_table.push({
          base_id: null,
          summa: 0,
          pay_type_id: this.globalPayType,
          type: this.globalType,
          source: this.globalSource,
          comment: ""
        });
      this.Tablefocus();
    },
    Addtableindex(index) {
      if (this.datas.kassa_order_table.length == index + 1) {
        this.datas.kassa_order_table.push({
          base_id: null,
          summa: 0,
          pay_type_id: this.globalPayType,
          type: this.globalType,
          source: this.globalSource,
          comment: ""
        });
      }
    },
    setGlobalType(val) {
      this.globalType = val;
      (this.datas.kassa_order_table || []).forEach(r => { r.type = val; });
      this.Summa();
    },
    setGlobalSource(val) {
      this.globalSource = val;
      (this.datas.kassa_order_table || []).forEach(r => { this.$set(r, "source", val); });
    },
    applyGlobalPayType(id) {
      this.globalPayType = id;
      (this.datas.kassa_order_table || []).forEach(r => { r.pay_type_id = id; });
      this.Summa();
    },
    findNaqdId(list) {
      const norm = s => (s || "").toString().toLowerCase();
      const found = (list || []).find(p => {
        const n = norm(p.name);
        return n.includes("накд") || n.includes("нақд") || n.includes("naqd") || n.includes("нал");
      });
      if (found) return found.id;
      return (list && list[0]) ? list[0].id : null;
    },
    initRowDefaults() {
      const rows = this.datas && this.datas.kassa_order_table;
      if (!rows || !rows.length) return;
      if (this.$route.path == "/kassaorder/create") {
        // Yangi hujjat: bo'sh qatorlarga standart (Накд + Чиқим) qo'yamiz
        rows.forEach(r => {
          if ((r.pay_type_id === null || r.pay_type_id === undefined) && this.globalPayType != null) {
            this.$set(r, "pay_type_id", this.globalPayType);
          }
          if (r.type === null || r.type === undefined) {
            this.$set(r, "type", this.globalType);
          }
          if (!r.source) {
            this.$set(r, "source", this.globalSource);
          }
        });
      } else {
        // Tahrirlash: yuqoridagi boshqaruvni birinchi qatorga moslab ko'rsatamiz
        if (rows[0].type === true || rows[0].type === false) this.globalType = rows[0].type;
        if (rows[0].pay_type_id) this.globalPayType = rows[0].pay_type_id;
        rows.forEach(r => { if (!r.source) this.$set(r, "source", "kassa"); });
        this.globalSource = rows[0].source || "kassa";
      }
      this.Summa();
    },
    Trashitem(index) {
      const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
      if (answer) {
        this.datas.kassa_order_table.splice(index, 1);
        this.Summa();
      }
    },
    Validate() {
      const rows = (this.datas && this.datas.kassa_order_table) || [];
      if (rows.length === 0) {
        this.$store.state.errors = this.$t("Камида битта қатор қўшинг");
        return false;
      }
      for (let i = 0; i < rows.length; i++) {
        const r = rows[i];
        const n = i + 1;
        if (r.type === null || r.type === undefined || r.type === "") {
          this.$store.state.errors = n + "-" + this.$t("қаторда Тури (Кирим/Чиқим) танланг");
          return false;
        }
        if (!r.base_id) {
          this.$store.state.errors = n + "-" + this.$t("қаторда Асос танланг");
          return false;
        }
        if (!r.pay_type_id) {
          this.$store.state.errors = n + "-" + this.$t("қаторда Тўлов тури танланг");
          return false;
        }
        if (!r.summa || parseFloat(r.summa) <= 0) {
          this.$store.state.errors = n + "-" + this.$t("қаторда Суммани киритинг");
          return false;
        }
      }
      return true;
    },
    Savedokument(type='default') {
      let self = this;
      if (!this.Validate()) {
        return;
      }
            // if(self.rule.change==true){
      if (this.$route.path == "/kassaorder/create") {
        var methods = "post";
        var action = "api/v1/kassa-order";
      } else {
        var methods = "patch";
        var action = "api/v1/kassa-order/id/" + self.$route.params.id;
      }
      //  self.datas.datetime = new Date(self.datas.datetime)
        // .valueOf()
        // .toString()
        // .slice(0, 10);
      axios({
        method: methods,
        url: action,
        data: self.datas
      }).then(function(response) {
        self.$store.state.saved = null;
        if(type=='save'){
          const path = "/kassaorder/update/" + response.data.id;
          if (self.$route.path !== path) self.$router.push({ path, query: self.$route.query });
        }else{
        self.$router.push(self.returnLocation);
        }
      });
    //    } else{
    //       self.$store.state.errors=self.$t('Sizdan bunday xuquq mavjud emas');
    // }
    }
  }
};
</script>

<style lang="scss" scoped>
/* SAHIFA ASOSI */
.g-page {
  padding: 24px;
  background: #f4f7f9;
  min-height: 100vh;
}

.content-container {
  max-width: 1400px;
  margin: 0 auto;
}

/* HEADER */
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-title {
  font-weight: 800;
  font-size: 24px;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
}

.doc-num {
  color: #a142f4;
  margin-left: 8px;
  font-size: 18px;
}

.back-circle-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #e0e6ed;
  background: white;
  color: #7f8c8d;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  cursor: pointer;
  text-decoration: none;
}

.back-circle-btn:hover {
  background: #a142f4;
  color: white;
  border-color: #a142f4;
}

.header-actions {
  display: flex;
  align-items: center;
}

.btn-change {
  background: #fff7ed;
  color: #d97706;
  border: 1px solid #fed7aa;
  padding: 8px 16px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
}

.btn-save {
  background: #a142f4;
  color: white;
  border: none;
  padding: 10px 22px;
  border-radius: 10px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.25);
  transition: 0.3s;
  cursor: pointer;
  white-space: nowrap;
}

.btn-save:hover:not(:disabled) {
  background: #8e39d9;
  transform: translateY(-1px);
}

.btn-save:disabled,
.btn-save-light:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-save sup {
  opacity: 0.7;
  font-size: 9px;
}

.btn-save-light {
  background: #f3e8ff;
  color: #8e39d9;
  border: 1px solid #e9d5ff;
  padding: 10px 18px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.btn-cancel {
  background: white;
  border: 1px solid #dcdde1;
  color: #7f8c8d;
  padding: 10px 18px;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}

/* MODERN CARD */
.modern-card {
  background: white;
  border-radius: 20px;
  padding: 24px 28px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.02);
  border: 1px solid #f1f2f6;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  color: #2c3e50;
  font-weight: 700;
  font-size: 15px;
}

.section-header svg {
  color: #a142f4;
}

/* FORM UNITS */
.form-unit {
  margin-bottom: 8px;
}

.form-unit label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #95a5a6;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.form-unit input {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #f8fafc;
  border-radius: 10px;
  padding: 9px 13px;
  color: #2c3e50;
  font-weight: 600;
  transition: 0.3s;
}

.form-unit input:focus {
  background: white;
  border-color: #a142f4;
  outline: none;
  box-shadow: 0 0 0 4px rgba(161, 66, 244, 0.05);
}

.form-unit input:disabled {
  background: #f1f5f9;
  color: #64748b;
}

.readonly-amount {
  background: #f8fafc;
  border-radius: 10px;
  padding: 9px 13px;
  font-weight: 800;
  text-align: right;
  font-size: 15px;
}

.amount-in { color: #16a34a; }
.amount-out { color: #e11d48; }

/* QATORLAR KARTASI */
.card-head-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.add-row-btn {
  background: linear-gradient(135deg, #a142f4 0%, #8b2cf5 100%);
  color: white;
  border: none;
  padding: 9px 18px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(161, 66, 244, 0.22);
}

.add-row-btn sup { opacity: 0.7; font-size: 9px; }

/* UMUMIY BOSHQARUV BARI */
.bulk-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  align-items: center;
  padding: 14px 18px;
  margin-bottom: 16px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 14px;
}

.bulk-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.bulk-label {
  font-size: 11px;
  font-weight: 700;
  color: #95a5a6;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  white-space: nowrap;
}

.kc-toggle {
  display: flex;
  gap: 6px;
}

.kc-btn {
  display: inline-flex;
  align-items: center;
  padding: 8px 18px;
  border-radius: 10px;
  border: 1px solid #e0e6ed;
  background: white;
  font-weight: 700;
  cursor: pointer;
  color: #7f8c8d;
  transition: 0.2s;
}

.kc-btn:hover:not(.active):not(:disabled) {
  border-color: #cbd5e1;
}

.kc-btn.kc-in.active {
  background: #16a34a;
  border-color: #16a34a;
  color: white;
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.25);
}

.kc-btn.kc-out.active {
  background: #e11d48;
  border-color: #e11d48;
  color: white;
  box-shadow: 0 4px 12px rgba(225, 29, 72, 0.25);
}

.kc-btn.kc-kassa.active {
  background: #2563eb;
  border-color: #2563eb;
  color: white;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
}

.kc-btn.kc-safe.active {
  background: #8b2cf5;
  border-color: #8b2cf5;
  color: white;
  box-shadow: 0 4px 12px rgba(139, 44, 245, 0.25);
}

.kc-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.bulk-select {
  min-width: 220px;
}

.table-wrapper {
  overflow-y: auto;
  max-height: 60vh;
}

.doc-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.doc-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 12px 10px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
}

.doc-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
}

.doc-table .req {
  color: #e11d48;
  font-weight: 800;
}

.doc-table .row-in { background: rgba(22, 163, 74, 0.03); }
.doc-table .row-out { background: rgba(225, 29, 72, 0.03); }
.doc-table tbody tr:hover { background: #faf5ff; }

.id-badge {
  background: #f1f5f9;
  padding: 4px 9px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
}

/* Jadval ichidagi inputlar */
.cell-input {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 8px;
  padding: 7px 10px;
  color: #2c3e50;
  font-weight: 600;
}

.cell-input:focus {
  background: white;
  border-color: #a142f4;
  outline: none;
}

.text-right { text-align: right; }

/* O'chirish tugmasi */
.icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
  cursor: pointer;
}

.icon-btn.del {
  background: #fff1f2;
  color: #e11d48;
}

.icon-btn.del:hover {
  background: #e11d48;
  color: white;
  transform: scale(1.1);
}

.empty-row {
  text-align: center;
  padding: 40px;
  color: #94a3b8;
  font-style: italic;
}

/* V-SELECT MOSLASH */
::v-deep .modern-vselect .vs__dropdown-toggle {
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 10px;
  padding: 3px 4px;
}

::v-deep .modern-vselect.vs--open .vs__dropdown-toggle {
  background: white;
  border-color: #a142f4;
}

::v-deep .modern-vselect.is-empty .vs__dropdown-toggle {
  border-color: #fca5a5;
  background: #fff5f5;
}

::v-deep .cell-select .vs__dropdown-toggle {
  min-height: 38px;
}

.modallist {
  border: none;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
}

.pluss {
  border: none;
  background: #a142f4;
  color: white;
  border-radius: 6px;
  padding: 2px 8px;
  margin-left: 6px;
}

@media (max-width: 768px) {
  .header-actions { flex-wrap: wrap; gap: 6px; justify-content: flex-end; }
  .modern-card { padding: 18px; }
}
</style>
